import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lot-information-block auction-status-block box-shadow"
}
const _hoisted_2 = { class: "auction-status-wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "link-dashed" }
const _hoisted_7 = {
  key: 1,
  class: "lot-information-block box-shadow"
}
const _hoisted_8 = { class: "current-lot-image-block" }
const _hoisted_9 = { class: "lot-favorite-mob" }
const _hoisted_10 = { class: "mobile-place-bid-wrapper" }
const _hoisted_11 = { class: "mobile-place-bid-block" }
const _hoisted_12 = { class: "current-bid-anim" }
const _hoisted_13 = { class: "current-lot-info" }
const _hoisted_14 = { class: "lot-number" }
const _hoisted_15 = { class: "lot-title" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 0,
  class: "lot-description"
}
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "metas" }
const _hoisted_20 = {
  key: 0,
  class: "metas__row catalog"
}
const _hoisted_21 = { class: "value" }
const _hoisted_22 = {
  key: 1,
  class: "metas__row catalog-value"
}
const _hoisted_23 = { class: "value" }
const _hoisted_24 = {
  key: 2,
  class: "metas__row condition"
}
const _hoisted_25 = {
  key: 0,
  class: "value"
}
const _hoisted_26 = { class: "lot-info-bottom" }
const _hoisted_27 = { class: "bids-count" }
const _hoisted_28 = { class: "mobile-current-lot-info" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "metas" }
const _hoisted_31 = {
  key: 0,
  class: "metas__row catalog"
}
const _hoisted_32 = { class: "value" }
const _hoisted_33 = {
  key: 1,
  class: "metas__row catalog-value"
}
const _hoisted_34 = { class: "value" }
const _hoisted_35 = {
  key: 2,
  class: "metas__row condition"
}
const _hoisted_36 = {
  key: 0,
  class: "value"
}

import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { formatCatalogValueRange, humanizedCatalog, humanizedCondition } from "@/utils/lot";
  import { AuctionStatuses } from "@/enum";
  import { trans } from "@/utils/trans";
  import FavoriteButton from "@/components/_partials/FavoriteButton.vue";
  import LotGallery from "@/components/_partials/LotGallery.vue";
  import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";
  import { format_currency } from "@/utils/currencies";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LotMainInfo',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const auctionStatus = computed(() => auctionStore.auction.status);

  const activeLot = computed(() => (auctionStore.activeLot?.id ? auctionStore.activeLot : auctionStore.fakeActiveLot));
  const catalog = computed(() => (activeLot.value ? humanizedCatalog(activeLot.value) : null));
  const condition = computed(() => (activeLot.value ? humanizedCondition(activeLot.value) : null));
  const catalogValue = computed(() => (activeLot.value ? formatCatalogValueRange(activeLot.value) : null));

  const currentBid = computed(() => auctionStore.activeLot?.current_bid);

return (_ctx: any,_cache: any) => {
  return (auctionStatus.value === _unref(AuctionStatuses).ENDED)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(trans)("live.auction_states.closed.title")), 1),
          _createElementVNode("a", {
            href: _unref(auctionStore).routes['site.auction.show'],
            class: "link-dashed"
          }, _toDisplayString(_unref(trans)("live.auction_states.closed.view_results")), 9, _hoisted_4),
          _createElementVNode("a", {
            href: _unref(auctionStore).routes['profile.invoices.index'],
            class: "link-dashed"
          }, _toDisplayString(_unref(trans)("live.auction_states.closed.my_purchases")), 9, _hoisted_5),
          _createElementVNode("button", _hoisted_6, _toDisplayString(_unref(trans)("live.auction_states.closed.contact_auctioneer")), 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(LotGallery, { class: "buyer-gallery" }),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(FavoriteButton, {
              "lot-id-prop": activeLot.value?.id,
              "subscribers-count-prop": activeLot.value?.subscribers_count,
              "show-count": ""
            }, null, 8, ["lot-id-prop", "subscribers-count-prop"])
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { id: "history-mobile-wrapper" }, [
            _createElementVNode("div", { class: "lot-timeline-messages" })
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_Transition, { name: "current-bid" }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("div", {
                    class: "current-bid",
                    key: currentBid.value ?? 0
                  }, _toDisplayString(_unref(format_currency)(currentBid.value)), 1))
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(trans)("live.common.main_info.lot_number", { number: activeLot.value?.lot_number })), 1),
          _createElementVNode("h1", _hoisted_15, _toDisplayString(activeLot.value?.title), 1),
          _createVNode(CustomScrollbar, { class: "custom-scrollbar mini lot-description-scrollbar controller-scrollbar" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "lot-description",
                innerHTML: activeLot.value?.description
              }, null, 8, _hoisted_16)
            ]),
            _: 1
          }),
          (activeLot.value?.note)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createTextVNode(_toDisplayString(_unref(trans)("live.common.main_info.note")) + ": ", 1),
                _createElementVNode("span", _hoisted_18, _toDisplayString(activeLot.value?.note), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            (catalog.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_unref(trans)("live.common.main_info.catalog")) + ": ", 1),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(catalog.value), 1)
                ]))
              : _createCommentVNode("", true),
            (catalogValue.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createTextVNode(_toDisplayString(_unref(trans)("live.common.main_info.catalog_value")) + ": ", 1),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(catalogValue.value), 1)
                ]))
              : _createCommentVNode("", true),
            (condition.value || activeLot.value?.condition_notes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createTextVNode(_toDisplayString(_unref(trans)("live.common.main_info.conditions")) + ": ", 1),
                  (condition.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(condition.value) + ".", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(activeLot.value?.condition_notes), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(trans)("live.common.main_info.bids", { bids: activeLot.value?.bids_count })), 1),
            _createVNode(FavoriteButton, {
              "lot-id-prop": activeLot.value?.id,
              "subscribers-count-prop": activeLot.value?.subscribers_count,
              "show-count": ""
            }, null, 8, ["lot-id-prop", "subscribers-count-prop"])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", {
            class: "lot-description",
            innerHTML: activeLot.value?.description
          }, null, 8, _hoisted_29),
          _createElementVNode("div", _hoisted_30, [
            (catalog.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createTextVNode(_toDisplayString(_unref(trans)("live.common.main_info.catalog")) + ": ", 1),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(catalog.value), 1)
                ]))
              : _createCommentVNode("", true),
            (catalogValue.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createTextVNode(_toDisplayString(_unref(trans)("live.common.main_info.catalog_value")) + ": ", 1),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(catalogValue.value), 1)
                ]))
              : _createCommentVNode("", true),
            (condition.value || activeLot.value?.condition_notes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createTextVNode(_toDisplayString(_unref(trans)("live.common.main_info.conditions")) + ": ", 1),
                  (condition.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(condition.value) + ".", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(activeLot.value?.condition_notes), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
}
}

})